// Handles merging environmental and build configs
define('ActionTagConfig',['jquery.amd','ActionTagGeneratedConfig'], function($, ActionTagGeneratedConfig) {
    // Parse global config settings from any form divs present on the page.
    // Form specific settings will be handled as we process each individual form.
    // If multiple forms exist on the page, we'll pull the setting from the first one with that setting
    // (So, don't set different global config values on different form divs!)
    function getFormData(settingName) {
        return $('.ngp-form').filter(function(){
            return !!$(this).data(settingName);
          }).first().data(settingName)
    }

    var formDataConfig = {
        DATABAG_SYNC_DOMAINS: getFormData('databagSyncDomains'),
        DATABAG_ENDPOINT: getFormData('databagEndpoint'),
        DATABAG_COOKIE_CONSENT: getFormData('databagCookieconsentmode'),
        DATABAG_SHARE_SETTING: getFormData('databag')
    };

    var defaultConfig = {
        DATABAG_SYNC_DOMAINS: ['https://secure.everyaction.com', 'https://secure.ngpvan.com'],
        DATABAG_ENDPOINT: 'https://profile.ngpvan.com/',
        PAYPAL_SESSION_TIMEOUT_MINUTES: 60,
        APPLE_PAY_SESSION_TIMEOUT_MINUTES: 8,
        VGS_POST_TIMEOUT_SECONDS: 30,
        // Asset locations for doublethedonation/matchpro functionality
        MATCH_PRO_SCRIPT_URL: 'https://doublethedonation.com/api/js/ddplugin.js',
        MATCH_PRO_CSS_URL: 'https://doublethedonation.com/api/css/ddplugin.css',
        FASTACTION_ENABLED: true
    };

    // Prefer the form config, then the generated config, then any default values
    return  _.defaults({}, formDataConfig, ActionTagGeneratedConfig, defaultConfig);
});

